import { useEffect, useState } from 'react'

type Orientation = 'portrait' | 'landscape'

/**
 * Hook to detect device orientation (portrait or landscape)
 * Listens to orientation changes and updates automatically
 * @returns Current device orientation
 */
export const useDeviceOrientation = (): Orientation => {
  const [orientation, setOrientation] = useState<Orientation>(() => {
    // Initial orientation
    return window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape'
  })

  useEffect(() => {
    const mediaQuery = window.matchMedia('(orientation: portrait)')

    const handleOrientationChange = (event: MediaQueryListEvent | MediaQueryList) => {
      setOrientation(event.matches ? 'portrait' : 'landscape')
    }

    // Modern browsers
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleOrientationChange)
    } else {
      // Fallback for older browsers
      mediaQuery.addListener(handleOrientationChange)
    }

    // Cleanup
    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handleOrientationChange)
      } else {
        mediaQuery.removeListener(handleOrientationChange)
      }
    }
  }, [])

  return orientation
}
